import { useQuery } from '@tanstack/react-query';
import AnalyticsServiceV2 from '../../services/v2/AnalyticsServiceV2';

const analyticsServiceV2 = AnalyticsServiceV2();

export const REACT_QUERY_GET_DASHBOARD_ANALYTICS_V2_QUERY_KEY = 'getDashboardAnalyticsV2';

export const useGetDashboardAnalyticsV2 = (params = {}, options = {}) => {
  const query = useQuery({
    queryKey: [REACT_QUERY_GET_DASHBOARD_ANALYTICS_V2_QUERY_KEY, params],
    queryFn: () => analyticsServiceV2.getDashboardAnalytics(params),
    ...options,
  });

  return query;
};
